import { Component, signal, WritableSignal } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { FieldTypeConfig } from '@ngx-formly/core'
import { FieldType } from '@ngx-formly/material'
import { selectOption } from 'src/types/wizard'

@Component({
    selector: 'gwc-multi-select',
    templateUrl: './multi-select.component.html',
    styleUrls: ['./multi-select.component.scss'],
    imports: [
      MatButtonModule
    ]
})

export class MultiSelectComponent extends FieldType<FieldTypeConfig> {
  public checkboxes: WritableSignal<selectOption[]> = signal([])

  ngOnInit(): void {
    this.checkboxes.set(this.props.options as Array<selectOption>)
  }

  public toggleOption(option: selectOption): void {
    let list = this.formControl.getRawValue() as string[] || []
    let value = option.value
    let index = list.indexOf(value)

    if (index >= 0) {
      list.splice(index, 1)
    } else {
      list.push(value)
    }

    this.formControl.patchValue(list)
  }
}
